import { render, staticRenderFns } from "./anchorNavigation.vue?vue&type=template&id=5fd719b0&scoped=true"
import script from "./anchorNavigation.vue?vue&type=script&lang=js"
export * from "./anchorNavigation.vue?vue&type=script&lang=js"
import style0 from "./anchorNavigation.vue?vue&type=style&index=0&id=5fd719b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd719b0",
  null
  
)

export default component.exports